import styles from "./AdminPanel.module.css";
import { useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setCookie } from "../Common";
import db from "../../firebase";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import logo from "../../images/logo.svg";
import {
  loginAdmin,
  addAdminError,
  removeAdminError,
} from "../../store/actions";
import {
  doc,
  collection,
  getDocs,
  query,
  where,
  updateDoc,
} from "firebase/firestore";

const AdminLogin = () => {
  const adminEmailRef = useRef();
  const adminPasswordRef = useRef();
  let history = useHistory();
  const dispatch = useDispatch();
  const adminLoginError = useSelector((state) => state.adminLoginError);

  const authAdmin = () => {
    const auth = getAuth();
    signInWithEmailAndPassword(
      auth,
      adminEmailRef.current.value,
      adminPasswordRef.current.value
    )
      .then((userCredential) => {
        async function setUser() {
          const q = query(
            collection(db, "user_data"),
            where("uid", "==", userCredential.user.uid)
          );
          const collectionnn = await getDocs(q);
          collectionnn.forEach((docc) => {
            if (docc.data().role === "admin") {
              setCookie("admin_active", userCredential.user.accessToken, 365);
              updateDoc(doc(db, "user_data", userCredential.user.uid), {
                token: userCredential.user.accessToken,
              });
              dispatch(loginAdmin());
              dispatch(removeAdminError());
            } else {
              alert("You're not an admin.");
              history.push("/");
            }
          });
        }
        setUser();
      })
      .catch(() => {
        dispatch(addAdminError());
      });
  };

  return (
    <section className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 text-center">
          <img src={logo} width="50px" height="auto" alt="Logo" />
          <h2 className={`${styles.heading} mt-4 mb-0`}>Admin Login</h2>
        </div>
        <div className="col-md-7 col-lg-5 mt-5">
          <input
            type="email"
            className={`${styles.formControl} form-control`}
            placeholder="Email"
            defaultValue="admin@biddify.com"
            ref={adminEmailRef}
          />
          <input
            type="password"
            className={`${styles.formControl} form-control mt-3`}
            placeholder="Password"
            defaultValue="#Admin4biddify.in#"
            ref={adminPasswordRef}
          />
          <button
            onClick={() => authAdmin()}
            className={`${styles.login_btn} btn mt-4`}
          >
            Login
          </button>
          {adminLoginError && (
            <div className="alert alert-danger mt-4" role="alert">
              Incorrect username or password!
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default AdminLogin;
